(() => {
  if (window.bundleSummaryReady) return;
  window.bundleSummaryReady = true;

  const format = (cents) => {
    const money = window.Shopify?.formatMoney
      ? window.Shopify.formatMoney(cents, window.Shopify.money_format)
      : (cents / 100).toFixed(2);
    return money.replace('.00', '');
  };

  const totalValue = () => {
    const root = document.querySelector('.bundle-price--tv');
    if (!root) return;
    const info = root.querySelector('.bundle-price__info');

    document.querySelectorAll('.bundle-price--tv .mt-prices, .mt-sticky-product-form__product-prices').forEach((el) => {
      const old = el.querySelector('s.mt-price--old');
      if (old) {
        const tv = document.createElement('span');
        tv.className = 'mt-price mt-price--old mt-price--tv';
        tv.textContent = `(${root.dataset.tvText.replace('[price]', old.textContent.trim())})`;
        old.replaceWith(tv);
      }
      el.classList.toggle('mt-prices--tv', !!el.querySelector('.mt-price--tv'));
      if (info && el.closest('.mt-sticky-product-form') && el.querySelector('.mt-price--tv') && !el.querySelector('.bundle-price__info')) {
        el.append(info.cloneNode(true));
      }
    });
  };

  const update = (prices) => {
    const pay = Number(prices.dataset.totalPrice || prices.dataset.price) || 0;
    const cap = Number(prices.dataset.totalCompareAtPrice) || Number(prices.dataset.compareAtPrice) || 0;
    const total = Math.max(cap, pay);
    const save = total - pay;

    document.querySelectorAll('[data-bundle-pay]').forEach((el) => (el.textContent = format(pay)));
    document.querySelectorAll('[data-bundle-total]').forEach((el) => (el.textContent = format(total)));
    document.querySelectorAll('[data-bundle-save]').forEach((el) => (el.textContent = format(save)));
    document.querySelectorAll('[data-bundle-has-saving]').forEach((el) => (el.hidden = save <= 0));
    totalValue();
  };

  const init = () => {
    const prices = document.querySelector('.mt-product__prices');
    if (!prices) return;
    update(prices);
    new MutationObserver(() => update(prices)).observe(prices, {
      attributes: true,
      attributeFilter: ['data-total-price', 'data-total-compare-at-price']
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
